@if (
  {
    otpData: otpData$ | async,
    loginCurrentUserData: loginCurrentUserData$ | async,
    isLoggingWithOneTimePassword: isLoggingWithOneTimePassword$ | async
  };
  as STATE
) {
  <custom-modal-card [enableClose]="false" class="registration-otp-modal">
    <ng-container body>
      <div class="registration-otp-modal__heading">
        <img
          [ngSrc]="'assets/images/otp.svg'"
          height="100"
          width="100"
          alt="Icône OTP"
        />
        <hgroup>
          <h2>Confirmez votre e-mail</h2>
          <p>
            Un code vient de vous être envoyé. Renseignez-le pour poursuivre la
            création du compte entreprise.
          </p>
        </hgroup>
      </div>

      <form class="form" [formGroup]="form">
        <!-- <div class="form__group">
          <label for="email" class="form__label">Adresse électronique</label>
          <div class="form__item form__item--with-prefix form__item--readonly">
            <span class="form__prefix">
              <mat-icon svgIcon="dgi-list-otp" color="primary"></mat-icon>
            </span>
            <input
              type="email"
              id="email"
              [value]="STATE.loginCurrentUserData?.email"
              class="form__input"
              placeholder="Entrez votre adresse électronique"
              readonly
              disabled
            />
          </div>
          <p class="form__hint">
            Un code de vérification à 6 chiffres a été envoyé à votre adresse
            e-mail.
          </p>
        </div> -->

        <div class="form__group">
          <label for="token" class="form__label"
            >Code OTP <span class="form__label--required">*</span></label
          >
          <div class="form__item form__item--with-prefix">
            <span class="form__prefix">
              <mat-icon svgIcon="dgi-list-otp" color="primary"></mat-icon>
            </span>
            <input
              type="text"
              id="token"
              formControlName="token"
              class="form__input"
              required
              mask="000000"
              [dropSpecialCharacters]="false"
              placeholder="Saisir le code à 6 chiffres"
            />
          </div>
          <auth-countdown
            [expiresAt]="STATE.otpData?.expiresAt"
            (resendOtp)="onOtpResend()"
          ></auth-countdown>
          <mat-error *ngIf="tokenControl?.touched && tokenControl?.errors">
            Le code est requis.
          </mat-error>
        </div>
      </form>
    </ng-container>

    <ng-container footer>
      <div class="modal-actions">
        <button
          button
          [disabled]="form.invalid"
          [loading]="!!STATE.isLoggingWithOneTimePassword"
          (click)="onSubmit()"
          loadingText="Validation en cours..."
        >
          Valider le code
        </button>
      </div>
    </ng-container>
  </custom-modal-card>
}
